/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import SubstanceMaterial from './SubstanceMaterial';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _find from 'lodash/find';
var SubstanceIbl = /** @class */ (function (_super) {
    __extends(SubstanceIbl, _super);
    function SubstanceIbl(rawAsset) {
        var _this = _super.call(this, rawAsset) || this;
        _this.isIbl = true;
        _this.isMaterial = false;
        _this.formats = ['sbsar', 'exr', 'stage'];
        _this._backplates = null;
        return _this;
    }
    Object.defineProperty(SubstanceIbl.prototype, "homePreview", {
        /**
         * Override the preview that is use on the homepage
         */
        get: function () {
            return this.flatPreview || this.mainPreview;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubstanceIbl.prototype, "previews", {
        get: function () {
            var flatPreview = this.findAttachments({
                __typename: 'PreviewAttachment',
                tag: 'flat',
            }) || [];
            var backplates = this.findAttachments({
                __typename: 'PreviewAttachment',
                tag: 'backplate',
            }) || [];
            var result = __spreadArray(__spreadArray([], __read(flatPreview), false), __read(backplates), false);
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubstanceIbl.prototype, "flatPreview", {
        get: function () {
            return this.findAttachment({
                __typename: 'PreviewAttachment',
                tag: 'flat',
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubstanceIbl.prototype, "backplates", {
        get: function () {
            if (this._backplates !== null)
                return this._backplates;
            var downloadBackplates = this.findAttachments({
                __typename: 'DownloadAttachment',
                tag: 'backplate',
            });
            var previewBackplates = this.findAttachments({
                __typename: 'PreviewAttachment',
                tag: 'backplate',
            });
            this._backplates = _map(downloadBackplates, function (backplate) {
                backplate.previewUrl = _get(_find(previewBackplates, { label: backplate.label }), 'url');
                return backplate;
            });
            return this._backplates;
        },
        enumerable: false,
        configurable: true
    });
    return SubstanceIbl;
}(SubstanceMaterial));
export default SubstanceIbl;
